module.exports = __webpack_public_path__ + "pic/63.314a2d0f.png";